import { render, staticRenderFns } from "./MaterialItemDrawer.vue?vue&type=template&id=7904c522"
import script from "./MaterialItemDrawer.vue?vue&type=script&lang=js"
export * from "./MaterialItemDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports